$( document ).ready(function() {
    let coreServicesBlock = $('.core-services');
    if(coreServicesBlock.length) {
        coreServices()
    }
});


function coreServices() {
    let coreServicesHead = $('.core-services__head');
    let coreServicesItems = coreServicesHead.find('.core-services__item');
    let coreServicesMainItems = $('.core-services__main-item');
    let coreServicesClose = $('.core-services__main-close');

    let coreServicesItemsClass = 'core-services__item--active'
    let coreServicesMainItemsClass = 'core-services__main-item--active'

    coreServicesItems.each(function (i, item) {
        $(item).on('click', function () {
            coreServicesMainOpen(i)
        })
    })

    function coreServicesMainOpen(i) {
        let statusClass = $(coreServicesItems[i]).hasClass(coreServicesItemsClass)
        coreServicesMainClose()
        if(statusClass) {
            $(coreServicesItems[i]).removeClass(coreServicesItemsClass)
            $(coreServicesMainItems[i]).slideUp()
        } else {
            $(coreServicesItems[i]).addClass(coreServicesItemsClass)
            $(coreServicesMainItems[i]).slideDown()
        }
    }
    coreServicesMainOpen(0)

    function coreServicesMainClose() {
        coreServicesItems.each(function (i, item) {
            $(item).removeClass(coreServicesItemsClass)
        })
        coreServicesMainItems.each(function (i, item) {
            $(item).slideUp()
        })
    }

    $(coreServicesClose).on('click', function () {
        $(this).parents('.core-services__main-item').slideUp()
        coreServicesMainClose()
    })

}